import React from 'react';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';

function FileViewer(props) {
  return (
    <div className={props.estado ? 'overlay active' : 'overlay'}>
      <div className={`full-screen`}>
        <button onClick={props.cambiarEstado} className="btn-close-fullmodal">
          <i className="material-icons"></i>
        </button>
        <DocViewer
          documents={props.docs}
          pluginRenderers={DocViewerRenderers}
          style={{ flex: 1, minHeight: 0, overflow: 'auto' }}
        />
      </div>
    </div>
  );
}

export default FileViewer;
